import { CloseIcon } from 'assets/icons/CloseIcon'
import { PlusIcon } from 'assets/icons/PlusIcon'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { addFoodCompanySettings } from 'features/food/foodSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { CursorPointer, Flex, SquareIcon } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const FoodCompanySettingsModal = ({ closeModal, value }: { closeModal: any, value?: IFoodCompanySettingsModalState }) => {
    const [state, setState] = useState(value || {
        maxMealsPerOperationalDay: null,
        mealTypePriorities: [
            { mealType: null, priority: 1, id: new Date().getTime() },
        ]
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(addFoodCompanySettings(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleMealTypeSelect = (v: ISelectValue, n: string, index: number) => {
        const newMtp = [...state.mealTypePriorities]
        newMtp[index].mealType = v
        setState({ ...state, mealTypePriorities: newMtp })
    }

    const handleMealTypePriorityChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const newMtp = [...state.mealTypePriorities]
        newMtp[index].priority = Number(e.target.value)
        setState({ ...state, mealTypePriorities: newMtp })
    }

    const handleAddMealTypePriority = () => {
        setState({
            ...state, mealTypePriorities: [
                ...state.mealTypePriorities,
                { mealType: null, priority: 1, id: new Date().getTime() }
            ]
        })
    }

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >Company Food Settings</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='15' labelText='Maximum amount of meals per day' value={state.maxMealsPerOperationalDay} onChange={e => setState({ ...state, maxMealsPerOperationalDay: e.target.value })} nomarg />
                <Flex column gap='0.5rem' >
                    <TitleText weight='bold' >Meal Type Priorities</TitleText>
                    {state.mealTypePriorities?.map((mtp, index) => (
                        <Flex key={index} gap='1rem' >
                            <HonestSelectAsyncInput
                                link='food/management/meal/type'
                                name='mealType'
                                labelText='Meal Type'
                                placeholder='Breakfast...'
                                defaultValue={mtp.mealType?.label}
                                onChange={(value, name) => handleMealTypeSelect(value, name, index)}
                                invalid={!mtp.mealType?.value}
                                parserFunction={(data: any) => data.data?.map((i: any) => ({ label: i.name, value: i.id }))}
                            />
                            <Input placeholder='1' labelText='Priority' value={mtp.priority}
                                onChange={e => handleMealTypePriorityChange(e, index)}
                                nomarg />
                        </Flex>
                    ))}
                    <Flex width='100%' end='true' mt='0.5rem' >
                        <SquareIcon onClick={handleAddMealTypePriority}>{PlusIcon}</SquareIcon>
                    </Flex>
                </Flex>

            </Flex>
            <Button variant='primary' onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IFoodCompanySettingsModalState {
    id?: number
    maxMealsPerOperationalDay: number
    mealTypePriorities: {
        id?: number
        mealType: ISelectValue
        priority: number
    }[]
}